import { useState } from 'react';
import { useAuth } from '../AuthContext';
import { useLanguage } from '../LanguageContext';
import translations from '../translations';
import './LoginPage.css';

function LoginPage({ onBack }) {
  const { signIn } = useAuth();
  const { language } = useLanguage();
  const t = translations[language];
  const [email, setEmail] = useState('silviasolt@gmail.com');
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const ALLOWED_EMAILS = ['silviasolt@gmail.com', 'official.sk@hotmail.com'];

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    if (!ALLOWED_EMAILS.includes(email.toLowerCase().trim())) {
      setError('This email is not authorised to sign in.');
      setLoading(false);
      return;
    }

    const { error } = await signIn(email);

    if (error) {
      setError(error.message);
      setLoading(false);
    } else {
      setSent(true);
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-box">
        {sent ? (
          <div className="login-sent">
            <div className="login-sent__icon">✉</div>
            <h2 className="login-sent__title">{t.checkEmail.split('—')[0].trim()}</h2>
            <p className="login-sent__text">{t.checkEmail}</p>
            <button className="login-back" onClick={onBack}>
              {t.backToHome}
            </button>
          </div>
        ) : (
          <>
            <h2 className="login-box__title">{t.loginTitle}</h2>
            <p className="login-box__subtitle">{t.loginSubtitle}</p>
            <form className="login-form" onSubmit={handleSubmit}>
              <label className="login-form__label" htmlFor="email">
                {t.emailLabel}
              </label>
              <input
                id="email"
                className="login-form__input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
              />
              {error && <p className="login-form__error">{error}</p>}
              <button
                className="login-form__submit"
                type="submit"
                disabled={loading}
              >
                {loading ? t.sending : t.sendMagicLink}
              </button>
            </form>
            <button className="login-back" onClick={onBack}>
              {t.backToHome}
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default LoginPage;
